import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../PlatformComponents/Sidebar";
import NavBar from "../PlatformComponents/NavbarPlatform";
import { TbGalaxy } from "react-icons/tb";
import ProjectView from "./ProjectView";
import NoSession from "../PlatformComponents/NoSession";
import ErrorPage from "../../Components/ErrorPage";

import { BsChevronBarLeft, BsChevronBarRight } from "react-icons/bs";

function ProjectPanel() {
  const navigate = useNavigate();
  const [loadingPage, setLoadingPage] = useState(true);
  const [no_session, SetNoSession] = useState(false);
  const [userData, setUserData] = useState(null);
  const [refreshSide, setRefreshSide] = useState(false);
  const [isSidebarClosed, setIsSidebarClosed] = useState(false);
  const user_id = sessionStorage.getItem("user_id");
  const [noProjAvailable, setNoProjAvailable] = useState(false);
  const { project_id } = useParams();
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null);

  const handleNavigation = (view) => {
    navigate(`/project_panel/${project_id}/${view}`);
  };

  const refreshSidebar = () => {
    setRefreshSide(true);
  };

  const handleToggleSidebar = () => {
    setIsSidebarClosed((prevState) => !prevState);
  };

  const fetchUserData = async () => {
    setLoadingPage(true);
    try {
      const response = await fetch(
        "https://backend.erioon.com/get_specific_project",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id, project_id }),
        }
      );

      if (!response.ok) throw new Error("Failed to fetch user data");

      const data = await response.json();
      setUserData(data);
      
      let openProject = data.projects._id
      if (openProject == project_id){
        let statusProject = data.projects.status

        if (statusProject == "deleting" || statusProject == "deleted_permanently"){
            navigate("/control_panel/projects")
        }
      } 

      setTimeout(() => {
        setLoadingPage(false);
      }, 1500);
    } catch (error) {
      setNoProjAvailable(true);
    }
  };

  useEffect(() => {
    if (!userData) fetchUserData();
    if (!user_id) {
      SetNoSession(true);
      setLoadingPage(true);
      setTimeout(() => navigate(`/login`), 3000);
    }
  }, [userData]);



  return (
    <div className="control_panel_cont">
      <NavBar onNavigate={handleNavigation} userData={userData} />
      <div className="project_panel_container">
        <div className={`project_panel_container_inner`}>

          <Sidebar
            onNavigate={handleNavigation}
            userData={userData}
            statusRefresh={refreshSide}
            isSidebarClosed={isSidebarClosed}
            setIsSidebarClosed={setIsSidebarClosed}
            isLoading={loadingPage}
          />
          <div
            className={`toggle_sidebar ${isSidebarClosed ? "toggle_sidebar_closed" : "toggle_sidebar_open"}`}
            onClick={handleToggleSidebar}
          >
            <i>
              {isSidebarClosed ? (
                <BsChevronBarRight />
              ) : (
                <BsChevronBarLeft />
              )}
            </i>
          </div>
          <div className={`main_nav_page ${isSidebarClosed ? "open_main_nav_page" : ""}`}>
            {no_session ? (
              <NoSession count={3} />
            ) : noProjAvailable ? (
              <ErrorPage />
            ) : loadingPage ? (
              <div className="loading_logo_erioon">
                <p className="loading_logo_erioon_icon">
                  <i>
                    <TbGalaxy />
                  </i>
                </p>
              </div>
            ) : (
              <ProjectView userData={userData} fetchUserData={fetchUserData} refreshSidebar={refreshSidebar} />
            )}
          </div>
        </div>

        {/* <MainAIChat fetchChats={fetchChats} chatId={chatId} setChatId={setChatId} aiChatOpen={aiChatOpen} setAiChatOpen={setAiChatOpen} /> */}
      </div>

    </div>
  );
}

export default ProjectPanel;
